// extracted by mini-css-extract-plugin
export default {"cls1":"AuthorHeader-cls1__c8f473b1e29d55bcc097","cls2":"AuthorHeader-cls2__d8755603465a80021d78 AuthorHeader-cls1__c8f473b1e29d55bcc097"};